import { Reveal } from "./Reveal";

export const SectionHeading = ({ kicker, title, desc, dark = false, children }) => (
  <div className="max-w-3xl">
    <Reveal>
      <div className="flex items-center gap-3">
        <span className="h-px w-10 bg-brand-red" />
        <span className="text-xs font-semibold tracking-[0.3em] uppercase text-brand-red">
          {kicker}
        </span>
      </div>
    </Reveal>
    <Reveal delay={0.08}>
      <h2
        className={`mt-5 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold uppercase tracking-tight leading-[1.05] ${
          dark ? "text-white" : "text-brand-ink"
        }`}
      >
        {title}
      </h2>
    </Reveal>
    {desc && (
      <Reveal delay={0.16}>
        <p className={`mt-5 text-base leading-relaxed ${dark ? "text-white/60" : "text-brand-ink/60"}`}>
          {desc}
        </p>
      </Reveal>
    )}
    {children}
  </div>
);
